import React from "react";

import { gridSpacing } from "@utils";

import Button from "../Button/Button";
import DropDown from "../DropDown/DropDown";

type SortButtonProps = {
  small?: boolean;
  sort: string;
  setSort: (sort: string) => void;
  options: { label: string; value: string }[];
};

const handleSortChange = (newSort: string, currentSort: string) => {
  if (currentSort === newSort) return `-${newSort}`;
  if (currentSort === `-${newSort}`) return "";
  return newSort;
};

const SortButton = ({ small, sort, setSort, options }: SortButtonProps) => (
  <DropDown onChange={(e) => setSort(handleSortChange(e, sort))}>
    <DropDown.Toggle>
      <Button
        small={small}
        icon={
          !sort
            ? "fa-regular fa-bars-sort"
            : `fa-regular fa-arrow-${sort.startsWith("-") ? "down" : "up"}-wide-short`
        }
        variant="secondary"
        text={
          sort && sort.length > 0
            ? options.find(
                (item) => item.value === sort || `-${item.value}` === sort,
              )?.label
            : "Sort by"
        }
        style={{
          minWidth: small ? 0 : undefined,
        }}
      />
    </DropDown.Toggle>
    <DropDown.Menu>
      {options.map((item) => {
        let sortDirection = null;
        if (sort === item.value || sort === `-${item.value}`) {
          sortDirection = sort.startsWith("-") ? "desc" : "asc";
        }

        return (
          <DropDown.Item key={item.value} value={item.value}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              {item.label}
              {sortDirection && (
                <i
                  className={`fa-regular fa-arrow-${sortDirection === "asc" ? "up" : "down"}`}
                  style={{
                    marginLeft: gridSpacing[2],
                  }}
                />
              )}
            </div>
          </DropDown.Item>
        );
      })}
    </DropDown.Menu>
  </DropDown>
);

export default SortButton;
